import * as React from 'react';
import { ICardActionsProps } from './types';
import './_CardIndicatorsMain.scss';
import { CardDatesHOC } from '../../CardDates/hocs/CardDatesHOC/CardDatesHOC';
import { CardIndicator } from '../../CardIndicator/CardIndicator';
import { CardPriorityHOC } from '../../../../../base/components/CardPriority/hocs/CardPriorityHOC/CardPriorityHOC';
import { ECardPriorityVariant } from '../../../../../base/components/CardPriority/components/CardPriority/types';
import { CARD_CLASS } from '../../../constants';
import { CardAssigneesHOC } from '../../CardAssignees/hocs/CardAssigneesHOC/CardAssigneesHOC';
import { CardEstimateHOC } from '../../CardEstimate/hocs/CardEstimateHOC';
import { NO_PRIORITY } from '../../../../../helpers/constants';
import { EViewTypes } from '../../../../../../../const';

export function CardIndicatorsMain({
    activeType,
    assignees,
    boardId,
    dueDate,
    cardId,
    estimate,
    isDatesOpened,
    isReadonly,
    isShowAssignees = true,
    isShowDueDate = true,
    isShowEmptyProperties = true,
    isShowEstimate = true,
    isShowPriority = true,
    isShowStartDate = true,
    listId,
    priority,
    source,
    startDate,
    onAssigneeClose,
    onAssigneeChange,
    onDateChange,
    setDatesOpened,
    onPriorityChange,
    setKeepOpen,
}: ICardActionsProps) {
    const className = CARD_CLASS + '__indicators-main';

    const [isOpenedAssignees, setOpenedAssignees] = React.useState(null);
    const [isOpenedDates, setOpenedDates] = React.useState(null);
    const [isOpenedEstimate, setOpenedEstimate] = React.useState(null);

    return (
        <div className={className}>
            {((isShowStartDate || isShowDueDate) && (isShowEmptyProperties || startDate || dueDate) || isOpenedDates) &&
                <CardDatesHOC
                    cardId={cardId}
                    boardId={boardId}
                    listId={listId}
                    startDate={startDate}
                    dueDate={dueDate}
                    isOpened={isDatesOpened}
                    isShowDue={isShowDueDate}
                    isShowStart={isShowStartDate}
                    onChange={onDateChange}
                    setDatesOpened={setDatesOpened}
                    source={source}
                    setOpen={(isOpen) => {
                        setOpenedDates(isOpen);
                        if (setKeepOpen) setKeepOpen(isOpen);
                    }}
                />
            }
            {(isShowEstimate && !!estimate || isOpenedEstimate) &&
                <CardEstimateHOC
                    cardId={cardId}
                    boardId={boardId}
                    source={source}
                    setOpen={(isOpen) => {
                        setOpenedEstimate(isOpen);
                        if (setKeepOpen) setKeepOpen(isOpen);
                    }}
                />
            }
            {
                (
                    !isReadonly &&
                    isShowPriority &&
                    (isShowEmptyProperties || priority && priority !== NO_PRIORITY) &&
                    activeType !== EViewTypes.PRIORITIES_VIEW_TYPE ||
                    isReadonly && priority && priority !== NO_PRIORITY
                ) &&
                <CardIndicator>
                    <CardPriorityHOC
                        cardId={cardId}
                        variant={ECardPriorityVariant.SMALL}
                        portal
                        listId={listId}
                        priority={priority}
                        source={source}
                        onChange={onPriorityChange}
                        onOpen={() => {
                            if (setKeepOpen) setKeepOpen(true)
                        }}
                        onClose={() => {
                            if (setKeepOpen) setKeepOpen(false)
                        }}
                    />
                </CardIndicator>
            }
            {
                (
                    (isShowAssignees &&
                    (isShowEmptyProperties || assignees && !!assignees.length) ||
                    isOpenedAssignees) &&
                    activeType !== EViewTypes.USERS_VIEW_TYPE
                ) &&
                <CardAssigneesHOC
                    assignees={assignees}
                    cardId={cardId}
                    listId={listId}
                    boardId={boardId}
                    source={source}
                    onChange={onAssigneeChange}
                    onClose={onAssigneeClose}
                    setOpen={(isOpen) => {
                        setOpenedAssignees(isOpen);
                        if (setKeepOpen) setKeepOpen(isOpen);
                    }}
                />
            }
        </div>
    );
}
